import { FC, useEffect, useState } from 'react';
import {
    Select,
    FormControl,
    InputLabel,
    Chip,
    MenuItem,
    Grid,
    Avatar,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import Swal from 'sweetalert2';
import Helper from '../../../../../utils/helper';
import { useTranslation } from 'react-i18next';
import { RPT, rptCls } from './scuiReturnProductTable.classes';

export const SCUIReturnProductTable: FC<{
    data: any;
    type: any;
    onChange?: any;
    returnReason?: any;
    returnReasonForAllUpdate?: any;
    className?: string;
}> = ({ data, type, onChange, returnReason, returnReasonForAllUpdate, className }) => {
    const { t } = useTranslation();
    const [returnResonSelectValue, setReturnResonSelectValue] = useState(
        data.reasonSelectForBarcode ? data.reasonSelectForBarcode : 0
    );
    const [quantitynSelectValue, setQuantitynSelectValue] = useState(
        data.quantitySelectForBarcode ? data.quantitySelectForBarcode : 0
    );
    const [photoClickType, setPhotoClickType] = useState('normal');

    useEffect(() => {
        if (returnReasonForAllUpdate) {
            setReturnResonSelectValue(returnReasonForAllUpdate);
        }
        if (returnReasonForAllUpdate && returnReasonForAllUpdate !== 0) {
            setQuantitynSelectValue(data.quantity);
        }
    }, [returnReasonForAllUpdate]);

    const handleClick = () => {
        setPhotoClickType(photoClickType === 'normal' ? 'action' : 'normal');
    };

    useEffect(() => {
        if (data.quantitySelectForBarcode === 0) {
            setReturnResonSelectValue(0);
        }
        if (data.quantitySelectForBarcode && Number(data.quantitySelectForBarcode) > Number(data.quantity)) {
            Swal.fire({
                icon: 'error',
                title: t('refund.cantAddMore'),
                showConfirmButton: false,
                timer: 1000,
            });
        } else {
            setQuantitynSelectValue(data.quantitySelectForBarcode);
        }
        if (data.reasonSelectForBarcode) {
            setReturnResonSelectValue(data.reasonSelectForBarcode);
        }
    }, [data && data.quantitySelectForBarcode]);

    let quantity: any = [];
    for (let i = 0; i <= data.quantity; i++) {
        quantity.push(
            <MenuItem className={RPT.quantitySelectItem} key={i} value={i} data-qty={i}>
                {i}
            </MenuItem>
        );
    }
    return (
        <Grid
            className={rptCls(RPT.root, className)}
            size={{
                sm: 12,
                md: 12,
                lg: 12,
                xl: 12,
            }}
        >
            <Paper
                className={RPT.paper}
                sx={{
                    boxShadow: 0,
                    marginBottom: 2,
                    backgroundColor:
                        data.quantitySelectForBarcode > 0 && returnResonSelectValue > 0 ? '#75c693' : 'white',
                }}
            >
                <div className={rptCls(RPT.content, 'sideBySideDiv')}>
                    <Avatar
                        className={rptCls(RPT.image, photoClickType === 'action' && RPT.imageBig, photoClickType === 'action' && 'makeAvatarImageBigger')}
                        sx={{
                            width: 132,
                            height: 132,
                            display: 'inline-block',
                            verticalAlign: 'top',
                        }}
                        variant="square"
                        src={data.productImageUrl}
                        onClick={handleClick}
                    />
                    <TableContainer className={RPT.tableContainer}>
                        <Table className={RPT.table} sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead className={RPT.tableHead}>
                                <TableRow className={RPT.tableHeadRow}>
                                    <TableCell
                                        className={RPT.tableHeadCell}
                                        style={{
                                            borderBottom: 'none',
                                            textAlign: 'center',
                                            width: '20px',
                                        }}
                                    >
                                        <b>{t('general.barcodeNumber')}</b>
                                    </TableCell>
                                    <TableCell
                                        className={RPT.tableHeadCell}
                                        style={{
                                            borderBottom: 'none',
                                            textAlign: 'center',
                                            width: '20px',
                                        }}
                                        align="center"
                                    >
                                        <b>{t('general.specialColorCode')}</b>
                                    </TableCell>
                                    <TableCell
                                        className={RPT.tableHeadCell}
                                        style={{
                                            borderBottom: 'none',
                                            textAlign: 'center',
                                            width: '150px',
                                        }}
                                        align="center"
                                    >
                                        <b>{t('general.productName')}</b>
                                    </TableCell>
                                    {type === 'show' && (
                                        <TableCell
                                            className={RPT.tableHeadCell}
                                            style={{
                                                borderBottom: 'none',
                                                textAlign: 'center',
                                                width: '150px',
                                            }}
                                            align="center"
                                        >
                                            <b>{t('general.brand')}</b>
                                        </TableCell>
                                    )}
                                    <TableCell
                                        className={RPT.tableHeadCell}
                                        style={{
                                            borderBottom: 'none',
                                            textAlign: 'center',
                                            width: '20px',
                                        }}
                                        align="center"
                                    >
                                        <b>{type === 'show' ? t('general.status') : t('general.size')}</b>
                                    </TableCell>
                                    <TableCell
                                        className={RPT.tableHeadCell}
                                        style={{
                                            borderBottom: 'none',
                                            textAlign: 'center',
                                            width: '40px',
                                        }}
                                        align="center"
                                    >
                                        <b>{type === 'action' && t('general.returnReason')}</b>{' '}
                                    </TableCell>
                                    <TableCell
                                        className={RPT.tableHeadCell}
                                        style={{
                                            borderBottom: 'none',
                                            textAlign: 'center',
                                            width: '20px',
                                        }}
                                        align="center"
                                    >
                                        <b>{t('general.quantity')}</b>
                                    </TableCell>
                                    <TableCell
                                        className={RPT.tableHeadCell}
                                        style={{
                                            borderBottom: 'none',
                                            textAlign: 'center',
                                            width: '20px',
                                        }}
                                        align="center"
                                    >
                                        <b>{t('general.price')}</b>
                                    </TableCell>
                                    <TableCell
                                        className={RPT.tableHeadCell}
                                        style={{
                                            borderBottom: 'none',
                                            textAlign: 'center',
                                            width: '20px',
                                        }}
                                        align="center"
                                    >
                                        <b>{t('general.cost')}</b>
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody className={RPT.tableBody}>
                                <TableRow className={RPT.tableBodyRow} sx={{ height: 50 }}>
                                    <TableCell
                                        className={RPT.tableBodyCell}
                                        component="th"
                                        scope="row"
                                        style={{
                                            borderBottom: 'none',
                                            textAlign: 'center',
                                            width: '20px',
                                        }}
                                    >
                                        {data.barcode}
                                    </TableCell>
                                    <TableCell
                                        className={RPT.tableBodyCell}
                                        align="center"
                                        style={{
                                            borderBottom: 'none',
                                            textAlign: 'center',
                                            width: '20px',
                                        }}
                                    >
                                        {data.ozelKod1}-{data.renkKod}
                                    </TableCell>
                                    <TableCell
                                        className={RPT.tableBodyCell}
                                        align="center"
                                        style={{
                                            borderBottom: 'none',
                                            textAlign: 'center',
                                            width: '150px',
                                        }}
                                    >
                                        {data.modelTitle}
                                    </TableCell>
                                    {type === 'show' && (
                                        <TableCell
                                            className={RPT.tableBodyCell}
                                            align="center"
                                            style={{
                                                borderBottom: 'none',
                                                textAlign: 'center',
                                                width: '150px',
                                            }}
                                        >
                                            {data.brandName}
                                        </TableCell>
                                    )}
                                    <TableCell
                                        className={RPT.tableBodyCell}
                                        align="center"
                                        style={{
                                            borderBottom: 'none',
                                            textAlign: 'center',
                                            width: '40px',
                                        }}
                                    >
                                        {type === 'show' && (
                                            <Chip
                                                className={RPT.statusChip}
                                                color={data.isReturnable ? 'success' : 'error'}
                                                label={
                                                    data.isReturnable
                                                        ? t('refund.refundable')
                                                        : t('refund.nonRefundable')
                                                }
                                            />
                                        )}
                                        {type === 'action' && <label>{data.size}</label>}
                                    </TableCell>
                                    <TableCell
                                        className={RPT.tableBodyCell}
                                        align="center"
                                        style={{
                                            borderBottom: 'none',
                                            textAlign: 'center',
                                            width: '40px',
                                        }}
                                    >
                                        {type === 'show' && <label>{data.returnMessage}</label>}
                                        {type === 'action' && (
                                            <FormControl className={RPT.reasonFormControl} sx={{ width: 300 }}>
                                                <InputLabel className={RPT.reasonSelectLabel} id="statusSelectLabel">
                                                    {t('general.returnReason')}
                                                </InputLabel>
                                                <Select
                                                    labelId="statusSelectLabel"
                                                    id="statusSelect"
                                                    label="Durum"
                                                    className={RPT.reasonSelect}
                                                    value={returnResonSelectValue}
                                                    onChange={(event) => {
                                                        setReturnResonSelectValue(Number(event.target.value));
                                                        onChange(event, data, 'Reason');
                                                    }}
                                                    disabled={!data.isReturnable}
                                                >
                                                    {returnReason &&
                                                        returnReason.map((item: any, index: number) => (
                                                            <MenuItem
                                                                className={RPT.reasonSelectItem}
                                                                key={index}
                                                                id={item.returnReasonId}
                                                                value={item.returnReasonId}
                                                                data-return-reason-id={item.returnReasonId}
                                                            >
                                                                {item.reasonName}
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        )}
                                    </TableCell>
                                    <TableCell
                                        className={RPT.tableBodyCell}
                                        align="center"
                                        style={{
                                            borderBottom: 'none',
                                            textAlign: 'center',
                                            width: '20px',
                                        }}
                                    >
                                        {type === 'show' ? (
                                            data.quantity
                                        ) : (
                                            <FormControl className={RPT.quantityFormControl} fullWidth>
                                                <InputLabel className={RPT.quantitySelectLabel} id="quantitySelectLabel">
                                                    {t('general.selectQuantity')}
                                                </InputLabel>
                                                <Select
                                                    labelId="quantitySelectLabel"
                                                    id="quantitySelect"
                                                    label={t('general.selectQuantity')}
                                                    className={RPT.quantitySelect}
                                                    value={quantitynSelectValue}
                                                    onChange={(event) => {
                                                        setQuantitynSelectValue(Number(event.target.value));
                                                        onChange(event, data, 'Quantity');
                                                    }}
                                                    disabled={!data.isReturnable}
                                                >
                                                    {quantity}
                                                </Select>
                                            </FormControl>
                                        )}
                                    </TableCell>
                                    <TableCell
                                        className={RPT.tableBodyCell}
                                        align="center"
                                        style={{ borderBottom: 'none', textAlign: 'center' }}
                                    >
                                        {Helper.formatNumber(data.price)}{' '}
                                        {data.currencySymbol || import.meta.env.VITE_CURRENCY!}
                                    </TableCell>
                                    <TableCell
                                        className={RPT.tableBodyCell}
                                        align="center"
                                        style={{ borderBottom: 'none', textAlign: 'center' }}
                                    >
                                        {Helper.formatNumber(data.netItemDiscountedPriceTotal)}{' '}
                                        {data.currencySymbol || import.meta.env.VITE_CURRENCY!}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </Paper>
        </Grid>
    );
};
